import { FC } from 'react';

import useCart from '@app/shop/hooks/useCart';
import useGTMTracking from '@app/shop/hooks/useGTMTracking';

import BillingAddress from './BillingAddress';
import ShippingBillingAddress from './ShippingBillingAddress';

const Address: FC = () => {
  const { cartId, isVirtual, items, prices, storeConfig, loading } = useCart();

  useGTMTracking({ step: 'address', items, prices, storeConfig });

  if (loading || !cartId) return null;

  return isVirtual ? (
    <BillingAddress cartId={cartId} />
  ) : (
    <ShippingBillingAddress cartId={cartId} />
  );
};

export default Address;
